export const formatFileName = (name: string, maxStart = 25) => {
  const ext = name.split(".").pop();
  const base = name.slice(0, maxStart);
  return `${base}.....${ext}`;
};
